module.exports = __webpack_public_path__ + "img/pointer.0da7d73b.png";